export const weapons = [
    {
        rarity: "common",
        class: "melee",
        name: "dagger",
        type: "light",
        group: "light blade",
        hardness: 10,
        hitPoints: 2,
        damage: "1d4",
        damageType: "P or S",
        crit: "19-20",
        range: "-",
        special: "-",
    },
    {
        rarity: "common",
        class: "melee",
        name: "Claw Blades",
        type: "augmenting",
        group: "Natural",
        hardness: 10,
        hitPoints: 2,
        damage: "1d3",
        damageType: "S",
        crit: "x2",
        range: "-",
        special: "Natural Augmenting",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Weapon Mount",
        type: "augmenting",
        group: "Natural",
        hardness: 10,
        hitPoints: 2,
        damage: "1d2",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "Natural Augmenting. You can attach this to a natural attack and a light or one-handed weapon at the same time, allowing you to use that weapon as if it was a Natural Augmenting weapon. The attack takes a -5 penalty, and if the natural attack was a secondary natural attack it takes an additional -5 penalty. The new combined weapon counts as one weapon for how enchantments stack.",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Mantis Blades",
        type: "augmenting",
        group: "close, natural",
        hardness: 10,
        hitPoints: 2,
        damage: "2d4",
        damageType: "P or S",
        crit: "x3",
        range: "-",
        special: "Natural Augmenting, Free Slot Unarmed Augmenting. Reach. This cannot augment bite attacks.",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Jagged Maw",
        type: "augmenting",
        group: "natural",
        hardness: 10,
        hitPoints: 2,
        damage: "1d6",
        damageType: "P or S",
        crit: "19-20x3",
        range: "-",
        special: "Natural Augmenting. This can only augment bite and claw attacks. Grapple. When you successfully grapple a creature with this weapon, you deal half the damage this weapon deals on an attack.",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Vicious Hook",
        type: "augmenting",
        group: "Natural",
        hardness: 10,
        hitPoints: 2,
        damage: "1d4",
        damageType: "S",
        crit: "x2",
        range: "-",
        special: "Natural Augmenting. Trip(+2). When you confirm a critical hit with this natural attack, you can make a free trip combat maneuver. This does not provoke. If it already did not provoke, you gain an additional +2.",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Vampire Fangs",
        type: "augmenting",
        group: "Natural",
        hardness: 10,
        hitPoints: 2,
        damage: "1d12",
        damageType: "P",
        crit: "18-20",
        range: "-",
        special: "Natural Augmenting. When you score a successful critical hit with this weapon on a living creature that is not immune to bleed damage, you heal hit points equal to half the damage done.",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Beast's Hide",
        type: "augmenting",
        group: "Natural",
        hardness: 5,
        hitPoints: 5,
        damage: "1d8",
        damageType: "P, B, or S",
        crit: "19-20",
        range: "-",
        special: "Natural Augmenting. This weapon augments all natural attacks of the same type at once, such as all claw attacks, or all tail attacks.",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Ball and Chain",
        type: "oneHanded",
        group: "Flail",
        hardness: 10,
        hitPoints: 10,
        damage: "2d8",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "Reach. You suffer a -1 penalty to armor class for 1 round whenever you make an attack with this weapon (stacks).",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Iron Jaws",
        type: "augmenting",
        group: "Natural",
        hardness: 10,
        hitPoints: 2,
        damage: "1d8",
        damageType: "S and P",
        crit: "x3",
        range: "-",
        special: "Natural Augmenting. A bite attack augmented with this weapon gains the grab special ability, and grants you a +1 armor bonus that stacks with other armor bonuses, however when casting spells with verbal components you suffer a 10% spell failure chance.",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "common",
        class: "armament",
        name: "Spark Stick",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "fire",
        crit: "x2",
        range: "30ft",
        special: "It costs 1 spell point to attack with this weapon. Your spells that deal damage deal extra damage as if struck by this weapon except it does not add your mental modifier. This only applies to a single damage roll during a spell.",
        spellPower:[{type:"universal", power:5}, {type:"fire", power:5}],
        spellCriticalChance:[{type:"universal", power:1}, {type:"fire", power:1}],
        spellCriticalDamage:[{type:"fire", power:10}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "rare",
        class: "armament",
        name: "Lucky Amulet",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d8",
        damageType: "fire",
        crit: "x4",
        range: "30ft",
        special: "It costs 1 spell point to attack with this weapon.",
        spellPower:[{type:"universal", power:5}],
        spellCriticalChance:[{type:"universal", power:4}],
        spellCriticalDamage:[{type:"universal", power:20}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "common",
        class: "armament",
        name: "Beginner's Wand",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "electricity",
        crit: "19-20",
        range: "30ft",
        special: "It costs 1 spell point to attack with this weapon. While wielding this weapon you can expend 3 spell points to allow a ray you are firing to use your mental modifier instead of dexterity to determine its attack roll. ",
        spellPower:[{type:"universal", power:5}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "common",
        class: "armament",
        name: "Earthen Staff",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "1d6",
        damageType: "acid",
        crit: "x2",
        range: "50ft",
        special: "It costs 1 spell point to attack with this weapon. Whenever you cast a spell while wielding this weapon you gain half the spell's level plus half the weapon's enhancement bonus as a shield bonus to your armor class until the start of your next turn. For every +5 of the weapon's enhancement bonus, the bonus lasts an additional round.",
        spellPower:[{type:"universal", power:5}, {type:"acid", power:5}],
        spellCriticalChance:[{type:"universal", power:1}, {type:"acid", power:1}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "common",
        class: "armament",
        name: "Rune Carved Glove",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "electricity",
        crit: "x2",
        range: "30ft",
        special: "It costs 1 spell point to attack with this weapon. Your spells that deal damage, deal extra damage equal to your highest mental modifier. This only applies to a single damage roll during a spell. When making a touch spell with this armament, your critical chance increases by 1%.",
        spellPower:[{type:"universal", power:5}, {type:"electricity", power:5}],
        spellCriticalChance:[{type:"universal", power:1}, {type:"electricity", power:1}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "common",
        class: "armament",
        name: "Amplification Ring",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1",
        damageType: "electricity",
        crit: "x2",
        range: "30ft",
        spCost: 1,
        special: "Your spells that deal damage, deal extra damage as if they had been struck by this weapon, except it does not add your mental modifier. This applies to every damage roll made by your spells.",
        spellPower:[{type:"universal", power:10}],
        spellCriticalDamage:[{type:"universal", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Ring of Charging",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d3",
        damageType: "force",
        crit: "x2",
        range: "50ft",
        spCost: 8,
        special: "Each time you cast a spell while wielding this ring you add additional charges to it equal to the level of the spell, this stacks. The next time you attack with this weapon all charges are discharged, for each charge expended it deals an additional 1d2 force damage. Spells cast between floors (such as stores) do not count.",
        spellPower:[{type:"universal", power:20}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Nullifying Staff",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "2d6",
        damageType: "cold",
        crit: "19-20",
        range: "50ft",
        spCost: 3,
        special: "Your spells gain a bonus on caster level checks to overcome spell resistance equal to this weapon's highest enhancement bonus. If you successfully attack a creature with this weapon, it has its spell resistance reduced by 1 until the end of your next turn. This stacks.",
        spellPower:[{type:"universal", power:10}, {type:"cold", power:15}],
        spellCriticalChance:[{type:"universal", power:1}, {type:"cold", power:1}],
        additionalInfoTags: ["Magical Armament"],
    },    
    {
        rarity: "legendary",
        class: "armament",
        name: "Laser Crystal",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "fire",
        crit: "x2",
        range: "50ft",
        spCost: 8,
        special: "When you attack a creature with this weapon, any creature's you have summoned gain a bonus on their next attack roll against them equal to this weapon's enhancement bonus, and deal additional damage as if you had struck them with this weapon, however the bonus damage becomes of the same type as the damage the creature was dealing to them.",
        spellPower:[{type:"universal", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Spellslinger's Ring",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "force",
        crit: "x3",
        range: "50ft",
        spCost: 6,
        special: "When you damage a creature with a spell, or it fails a save against a spell you cast, any time within the next round you can make an attack with this ring as an immediate action against them, following usual restrictions.",
        spellPower:[{type:"universal", power:20}],
        spellCriticalChance:[{type:"universal", power:3}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "rare",
        class: "armament",
        name: "Ring of Devastation",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d6",
        damageType: "cold",
        crit: "19-20",
        range: "30ft",
        spCost: 2,
        special: "This weapon grants 5 universal spell power, 4% universal spell critical chance, and 5% universal spell critical damage, and 10% cold spell critical damage.",
        spellPower:[{type:"universal", power:5}],
        spellCriticalChance:[{type:"universal", power:4}],
        spellCriticalDamage:[{type:"universal", power:10}, {type:"cold", power:10}],
        additionalInfoTags: ["Magical Armament"],
    },
    // {
    //     rarity: "rare",
    //     class: "ranged",
    //     name: "Wand of Devastation",
    //     group: "Magical Armament",
    //     hardness: 5,
    //     hitPoints: 2,
    //     handsNeeded: "one",
    //     type: "armament",
    //     damage: "1d6",
    //     damageType: "acid",
    //     crit: "19-20",
    //     range: "30ft",
    //     special: "It costs 2 spell points to attack with this weapon. All of your spells have their base critical threat range become this ring's base critical threat range. This includes variant critical threat ranges that you possess, such as for concentration.",
    //     additionalInfoTags: ["Magical Armament"],
    // },
    {
        rarity: "rare",
        class: "armament",
        name: "Flame Blade",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 5,
        handsNeeded: "one",
        type: "armament",
        damage: "1d8",
        damageType: "Fire",
        crit: "18-20",
        range: "melee",
        spCost: 1,
        special: "Finessable. When you cast a spell, the flame blade becomes empowered until the end of your next turn, gaining a bonus on attack and damage equal to the level of the spell. This counts as a melee weapon.",
        spellPower:[{type:"universal", power:3}, {type:"fire", power:10}],
        spellCriticalChance:[{type:"fire", power:1}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Lantern of Light",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 2,
        handsNeeded: "two",
        type: "armament",
        damage: "1d8",
        damageType: "Positive energy",
        crit: "x2",
        range: "30ft.",
        spCost: 2,
        special: "Whenever you cast a buff spell on a creature, they heal hit points as if you hit them with this weapon. When attacking to heal or using the effect all damage enchantments are converted to healing except continuous ones.",
        spellPower:[{type:"universal", power:5}, {type:"positive", power:15}],
        spellCriticalChance:[{type:"positive", power:2}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "common",
        class: "armament",
        name: "Transference Ring",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d6",
        damageType: "negative energy",
        crit: "x2",
        range: "30ft.",
        spCost: 2,
        special: "Whenever you spend spell points, you heal an equal amount of hit points. If you kill a creature with this weapon, you regain spell points equal to half the damage dealt on the attack that killed them.",
        spellPower:[{type:"universal", power:5}, {type:"negative", power:15}],
        spellCriticalChance:[{type:"negative", power:2}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "Blood Lord's Nail",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d8",
        damageType: "siphon",
        crit: "x2",
        range: "self only",
        spCost: 6,
        special: "When you take damage from this weapon, your next spell before the end of your next turn gains a percentage critical chance equal to 1/10 the damage taken. This stacks.",
        spellPower:[{type:"universal", power:15}, {type:"negative", power:15}],
        spellCriticalDamage:[{type:"universal", power:15}, {type:"negative", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "Deathfire Grasp",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "2d6",
        damageType: "fire",
        crit: "x2",
        range: "30ft",
        spCost: 5,
        special: "When you strike a creature with this weapon, it increases any damage they take from spells or magical perks by a percentage equal to the damage this weapon dealt. This lasts until the end of your next turn. If you attack a creature that is currently under this effect, it does not stack, instead increases the duration of it by 1 round, and uses the new damage if that would be higher. This damage is not increased by critical spells.",
        spellPower:[{type:"universal", power:25}],
        spellCriticalChance:[{type:"universal", power:4}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "rare",
        class: "armament",
        name: "Vambrace of the Battlemage",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 5,
        handsNeeded: "one",
        type: "armament",
        damage: "1d8",
        damageType: "B",
        crit: "x2",
        range: "10ft",
        spCost: 1,
        special: "Whenever you cast a spell, you gain a bonus on the concentration checks equal to half this weapon's enhancement modifier, and all creatures within the weapon's range take damage as if struck by this weapon.",
        spellPower:[{type:"universal", power:15}],
        spellCriticalDamage:[{type:"universal", power:10}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Shield of the Battlemage",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 5,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "B",
        crit: "x2",
        range: "self",
        spCost: 2,
        special: "When you strike a creature with this weapon or cast a spell that targets only you, you gain temporary hit points equal to the damage this weapon would deal (except continuous damage). When a creature strikes you and removes the temporary hit points gained from this item, it takes damage equal to the granted temporary hit points it removed. As long as you have temporary hit points from this item, you gain a deflection bonus to your armor class equal to half this weapon's enhancement bonus.",
        spellPower:[{type:"universal", power:10}],
        spellCriticalDamage:[{type:"universal", power:20}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Tome of Power",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 5,
        handsNeeded: "two",
        type: "armament",
        damage: "2d8",
        damageType: "fire or electricity",
        crit: "x3",
        range: "50ft",
        spCost: 2,
        special: "Spells you cast while wielding this weapon gain increased spell power equal to the total enhancement bonus of this weapon.",
        spellPower:[{type:"universal", power:10}, {type:"fire", power:15}, {type:"electricity", power:15}],
        spellCriticalChance:[{type:"universal", power:4}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Book of the Mad Mage",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 5,
        handsNeeded: "two",
        type: "armament",
        damage: "2d8",
        damageType: "cold or acid",
        crit: "x3",
        range: "50ft",
        spCost: 2,
        special: "Spells you cast while wielding this weapon gain a percentage critical chance equal to 1/2 weapon's enhancement bonus (rounded down). They also gain a critical failure chance of 1/3 of the weapon's enhancement bonus (rounded up).",
        spellPower:[{type:"universal", power:10}, {type:"cold", power:15}, {type:"acid", power:15}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "Money Gang Ring",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d8",
        damageType: "negative energy",
        crit: "x3",
        range: "50ft",
        spCost: 3,
        special: "This weapon gains bonus spell power based on the total enchantments of this weapon. When you cast an instantaneous AoE damage spell, you can spend gold to give that spell a percentage critical chance of half the amount spent, up to 200 gold for 100% critical chance. If this chance succeeds, its area also doubles.",
        spellPower:[{type:"universal", power:25}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "Blood Orb",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 20,
        handsNeeded: "one",
        type: "armament",
        damage: "2d6",
        damageType: "siphon",
        crit: "19-20x3",
        range: "30ft",  
        spCost: 4,
        special: "This weapon deals siphon damage (see crimson reaper discipline info). When you cast a damage spell and at least one creature takes damage from it, you heal hit points equal the damage this weapon deals. If you attack with this weapon, it heals you for hit points equal to the damage dealt. This counts as natural healing, not magical. If you have the hemomancy perk, your siphon deals additional damage as if struck by this weapon and gains 5% spell critical chance and 25% spell critical damage.",
        spellPower:[{type:"universal", power:15}, {type:"negative", power:15}],
        spellCriticalChance:[{type:"universal", power:2}, {type:"negative", power:2}],
        spellCriticalDamage:[{type:"universal", power:15}, {type:"negative", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "Elder Wand",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "2d6",
        damageType: "electricity",
        crit: "18-20",
        range: "50ft",
        spCost: 2,
        special: "Your damage ray spells that you cast while wielding this weapon gain the wands enhancement bonus to its attack rolls and deal additional damage as if struck by this weapon, though its base damage becomes that of the type of the spell (unless it has none, then it is the wands damage).",
        spellPower:[{type:"universal", power:25}],
        spellCriticalChance:[{type:"universal", power:10}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Blinking Bracer",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 10,
        handsNeeded: "one",
        type: "armament",
        damage: "1d8",
        damageType: "B",
        crit: "18-20",
        range: "30ft",
        spCost: 3,
        special: "Whenever you complete an attack with this weapon, or successfully cast a spell, you can teleport 5 feet. For every +4 total enhancement bonus this weapon has, the distance increases by 5 feet. Whenever you cast a conjuration(teleportation) spell you gain temporary hit points equal to being struck with this weapon (except continuous damage) for 1 minute.",
        spellPower:[{type:"universal", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Spike Staff",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "armament",
        damage: "1d8",
        damageType: "B",
        crit: "x2",
        range: "60ft",
        spCost: 3,
        special: "Whenever you target a creature with a spell, or the furthest point away from you with a burst or line spell, or attack a creature with this weapon, a spike is placed at the targeted location (once per spell). Then, as a standard action while wielding this weapon you can withdraw all spikes on the map to your location, damaging all creatures the spikes passes through as if struck by this weapon. Multiple spikes can deal damage multiple times to a creature. Spikes on a creatures location when recalled do not damage them. Once a spike is used it is destroyed. The recall damage gains bonus damage from earth and universal spell power.",
        spellPower:[{type:"universal", power:15}, {type:"acid", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Wardrums",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "1d8",
        damageType: "sonic",
        crit: "x3",
        range: "20ft. circle",
        spCost: 6,
        special: "Scatter. When you attack with this weapon, it strikes all creatures within the area. You can cast a single buff spell that doesn't have a range of personal on a single creature hit by this weapon as a swift action, and the spell cost is halved. If the spell would normally target multiple creatures it only targets the single creature, and the buff lasts only a single round. For every +5 of this weapon's enhancement bonus the buff lasts an additional round.",
        spellPower:[{type:"universal", power:15}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Staff of Protection",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "1d6",
        damageType: "acid",
        crit: "x2",
        range: "50ft",
        spCost: 1,
        special: "Whenever you cast a spell that grants a bonus to armor class, the bonus increases by the weapon's enhancement bonus (minimum +1) for 1 round. Each subsequent round the granted bonus is reduced by half (minimum 0). When a creature strikes a target that still has a bonus from this armament, it takes damage as if struck by this weapon, except your mental modifier. This doesn't stack.",
        spellPower:[{type:"universal", power:15}],
        spellCriticalChance:[{type:"universal", power:2}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Book of Hysteria",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 5,
        handsNeeded: "two",
        type: "armament",
        damage: "1d6",
        damageType: "emotional",
        crit: "x2",
        range: "50ft",
        spCost: 1,
        special: "Emotional damage has no effect on creatures with an intelligence less than 3 or creatures immune to emotion or mind-affecting effects. When you cast a spell that grants a morale bonus, the bonus given is doubled for 1 round per +2 enhancement bonus this weapon has. Each round a creature is suffering from a negative emotion effect you gave them with a spell, they suffer damage as if struck by this weapon.",
        spellPower:[{type:"universal", power:20}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:10}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "The Mortal Coil",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 5,
        handsNeeded: "two",
        type: "armament",
        damage: "1d10",
        damageType: "untyped",
        crit: "x4",
        range: "50ft",
        spCost: 7,
        special: "This weapon deals full damage to all creatures, even incorporeal ones. Each time you deal damage with this weapon to a non-helpless enemy, you gain experience equal to the damage dealt (except damage done after they are reduced to hit points that would make them helpess). If you have the hemomancy perk, your siphons gain this effect and 5% spell critical chance and 50% spell critical damage.",
        spellPower:[{type:"universal", power:15}, {type:"negative", power:25}],
        spellCriticalChance:[{type:"universal", power:2}, {type:"negative", power:2}],
        spellCriticalDamage:[{type:"universal", power:15}, {type:"negative", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Missile Gatling",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 5,
        handsNeeded: "two",
        type: "armament",
        damage: "1d4",
        damageType: "force",
        crit: "18-20",
        range: "60ft",
        spCost: 1,
        special: "Each time you deal damage with this weapon, the damage the creature takes from subsequent missiles from this weapon increases by +1.",
        spellPower:[{type:"universal", power:5}],
        spellCriticalChance:[{type:"universal", power:1}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Blaze Rod",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "fire",
        crit: "x2",
        range: "20ft. cone",
        spCost: 5,
        special: "Scatter. If a creature fails a save against a damage spell you cast, or when struck by this weapon, they also catch on fire, taking damage as if struck by this weapon without the ability score modifier to damage each round until they make a reflex save DC 10 + highest mental + weapon's enhancement bonus. This stacks with other sources of catching on fire (but not itself, or other blaze rods).",
        spellPower:[{type:"universal", power:10}, {type:"fire", power:15}],
        spellCriticalChance:[{type:"universal", power:1}, {type:"fire", power:2}],
        spellCriticalDamage:[{type:"universal", power:10}, {type:"fire", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Ooze Jar",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "acid",
        crit: "x2",
        range: "30ft. line",
        spCost: 5,
        special: "Scatter. When a creature fails a saving throw against a damage spell you cast, they have their armor bonus to armor class reduced by an amount equal to the enhancement bonus of this weapon for the next attack against them per level of the spell, and on your next turn they take additional damage as if struck by this weapon. If they have no armor bonus, it instead reduces natural armor. It cannot reduce either below 0.",
        spellPower:[{type:"universal", power:5}, {type:"acid", power:15}],
        spellCriticalChance:[{type:"universal", power:2}, {type:"acid", power:1}],
        spellCriticalDamage:[{type:"universal", power:5}, {type:"acid", power:20}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "Jar of Water",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "acid",
        crit: "x2",
        range: "15ft. cone",
        spCost: 4,
        special: "Scatter. When a creature takes damage from a spell you cast (once per turn per creature), on your next turn they take additional damage equal to being struck by this weapon. Each following round they take half the damage they took the previous round from this weapon.",
        spellPower:[{type:"universal", power:15}, {type:"acid", power:15}],
        spellCriticalChance:[{type:"universal", power:2}, {type:"acid", power:2}],
        spellCriticalDamage:[{type:"universal", power:10}, {type:"acid", power:20}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "rare",
        class: "armament",
        name: "Blessed Book",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 5,
        handsNeeded: "one",
        type: "armament",
        damage: "1d6",
        damageType: "Positive Energy",
        crit: "x2",
        range: "20ft",
        spCost: 2,
        special: "If you cast a spell that rolls dice to heal hit points, it heals additional hit points equal to your highest mental modifier plus the enhancement bonus on this weapon. This only applies to the first roll during the spell.",
        spellPower:[{type:"universal", power:5}, {type:"positive", power:10}],
        spellCriticalChance:[{type:"positive", power:2}],
        spellCriticalDamage:[{type:"positive", power:10}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "rare",
        class: "armament",
        name: "High Priest's Staff",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "1d6",
        damageType: "Positive Energy",
        crit: "x2",
        range: "40ft",
        spCost: 2,
        special: "When a spell you cast heals hit points, the healed creature also gains temporary hit points equal to the damage of this weapon, not including your mental modifier. These do not stack with themselves. When attacking to heal or using its effect, all damage enchantments are converted to temporary hit points (except continuous ones).",
        spellPower:[{type:"universal", power:5}, {type:"positive", power:10}],
        spellCriticalChance:[{type:"positive", power:2}],
        spellCriticalDamage:[{type:"positive", power:10}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "rare",
        class: "armament",
        name: "Missile Wand",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d4",
        damageType: "force",
        crit: "19-20",
        range: "100ft",
        spCost: 2,
        special: "For every 3 levels of spells you possess, you can spend an additional spell point while attacking to fire an additional missile. This weapon grants 5 universal spell power and 15% spell critical damage.",
        spellPower:[{type:"universal", power:5}],
        spellCriticalDamage:[{type:"universal", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "rare",
        class: "armament",
        name: "Summoning Jar",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 2,
        handsNeeded: "two",
        type: "armament",
        damage: "1d4",
        damageType: "bludgeoning",
        crit: "x2",
        range: "30ft",
        spCost: 1,
        special: "If you use this weapon to attack, it gains the bonuses from any abilities you have that modify your rocks. When you cast a spell that summons a creature, the first attack they make gains a bonus to the attack roll equal to this weapon's enhancement bonus, and deals bonus damage as if this weapon had struck them. This damage increases with acid spell power.",
        spellPower:[{type:"universal", power:5}, {type:"acid", power:10}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "rare",
        class: "armament",
        name: "Magic Wand",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "armament",
        damage: "1d8",
        damageType: "fire",
        crit: "x2",
        range: "50ft",
        spCost: 1,
        special: "When casting a ray spell you can add the enchantments of this weapon to it, including enhancement modifiers to both attack and damage.",
        spellPower:[{type:"universal", power:5}, {type:"fire", power:5}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Electric Lute",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "1d8",
        damageType: "sonic",
        crit: "19-20",
        range: "50ft",
        spCost: 1,
        special: "When you cast a spell of the buff type, the next weapon attack made by the creatures targeted by the spell deal additional damage as if you had struck them with this weapon (doesn't stack). This bonus damage gains double damage from universal spell power. This weapon grants 5 universal spell power.",
        spellPower:[{type:"universal", power:15}],
        spellCriticalChance:[{type:"universal", power:2}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Red Mage's Staff",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "1d4",
        damageType: "Fire",
        crit: "19-20x3",
        range: "50ft",
        spCost: 1,
        special: "When you cast a spell that does damage, it deals extra damage as if you had struck them with this weapon. This only applies to a single damage roll during a spell.",
        spellPower:[{type:"universal", power:10}, {type:"fire", power:15}],
        spellCriticalChance:[{type:"universal", power:2}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Tormentor's Staff",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "1d8",
        damageType: "Acid",
        crit: "19-20",
        range: "50ft",
        spCost: 1,
        special: "When you cast a spell that does damage, except for damage done on the round it is cast, it deals extra damage as if struck by this weapon, except it does not add your ability modifier. This can apply as many times as the spell deals damage.",
        spellPower:[{type:"universal", power:10}, {type:"acid", power:15}],
        spellCriticalDamage:[{type:"universal", power:20}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Book of Runes",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "one",
        type: "armament",
        damage: "2d6",
        damageType: "cold",
        crit: "x2",
        range: "40ft",
        spCost: 3,
        special: "Each time you make a successful attack with this weapon it gains a charge. Then when you cast a spell, you can expend all charges to give the spell a bonus to its spell power equal to the stacks expended * 1 + weapon's enhancement bonus.",
        spellPower:[{type:"universal", power:10}, {type:"cold", power:10}],
        spellCriticalChance:[{type:"cold", power:2}],
        spellCriticalDamage:[{type:"cold", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Staff of Babylon",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "1d8",
        damageType: "fire",
        crit: "x3",
        range: "60ft",
        spCost: 2,
        special: "While you wield this weapon, you can can cause additional armaments, rods, or impliments to float around the staff, to a maximum of the weapon's enhancement modifier. You are able to use any of these items (except armaments) as a part of casting spells. For each item floating around the staff, it gains a +1 bonus on attack and damage rolls, and all spells you cast gain a bonus depending on the floating items: Armaments: +5 universal spell power, Rod: +1 DC, Implement: +2 damage.",
        spellPower:[{type:"universal", power:10}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Lord's Gauntlet",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 5,
        handsNeeded: "one",
        type: "armament",
        damage: "1d6",
        damageType: "force",
        crit: "x3",
        range: "40ft",
        spCost: 1,
        special: "It costs 1 spell point to attack with this weapon. Creatures who fail a save against a control spell that you cast take damage as if hit by this weapon, which scales with 200% universal spell power.",
        spellPower:[{type:"universal", power:20}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "Magitech Gun",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 5,
        handsNeeded: "two",
        type: "armament",
        damage: "1d8",
        damageType: "B",
        crit: "x4",
        range: "60ft",
        spCost: 2,
        special: "While wielding this weapon, cone, line, or ray spells gain half this weapon's enhancement modifier as a bonus to the spell's DC or on its attack roll. If a creature rolls a natural 20 on a save against a spell empowered by this weapon, or if you roll a natural 1 on a ray attack, the weapon becomes broken, reducing the bonuses it grants by half, and increasing the range of rolls required for it to missfire again by +4. If already broken, then it is destroyed instead. This item can be fixed as if it was a firearm.",
        spellPower:[{type:"universal", power:15}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Focusing Orb",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 5,
        handsNeeded: "one",
        type: "armament",
        damage: "1d12",
        damageType: "electricity",
        crit: "19-20",
        range: "50ft",
        spCost: 1,
        special: "When casting a ray spell while wielding weapon you can add the enchantments of this weapon to it.",
        spellPower:[{type:"universal", power:5}],
        spellCriticalChance:[{type:"universal", power:4}],
        spellCriticalDamage:[{type:"universal", power:20}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "epic",
        class: "armament",
        name: "Voodoo Doll",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "two",
        type: "armament",
        damage: "1d8",
        damageType: "negative energy",
        crit: "19-20",
        range: "50ft",
        spCost: 3,
        special: "If you attack and deal damage to a creature with this weapon, the next save it makes against a control spell you cast has a penalty equal to half the weapon's enhancement modifier (doesn't stack).",
        spellPower:[{type:"universal", power:10}, {type:"negative", power:15}],
        spellCriticalChance:[{type:"universal", power:1}, {type:"negative", power:2}],
        spellCriticalDamage:[{type:"universal", power:10}, {type:"negative", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "legendary",
        class: "armament",
        name: "The Black Book",
        group: "Magical Armament",
        hardness: 2,
        hitPoints: 2,
        handsNeeded: "two",
        type: "armament",
        damage: "1d8",
        damageType: "negative energy",
        crit: "x3",
        range: "40ft",
        spCost: 3,
        special: "Each time you hit and deal damage with this when attacking with this weapon, it gains a black seal. When you cast a spell, you can expend all black seals to increase the DC of the spell by 1 for every 2 black seals. This only applies to the initial saving throws against the spell, not any subsequent ones on further rounds.",
        spellPower:[{type:"universal", power:15}, {type:"negative", power:15}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:20}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "Grimoire of Destruction",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 5,
        type: "armament",
        handsNeeded: "two",
        damage: "3d6",
        damageType: "fire or cold",
        crit: "x4",
        range: "50ft., Area: 10ft. square.",
        spCost: 5,
        special: "Scatter. When casting an area of effect spell you can add the damage dealt by this weapon attack to a single damage roll made during the cast of the spell, the bonus damage is of the damage type of the damage roll you're adding the damage to, except damage enchantments, which stay the type they are, such as frost or holy.",
        spellPower:[{type:"universal", power:15}, {type:"fire", power:20}, {type:"cold", power:20}],
        spellCriticalChance:[{type:"universal", power:2}, {type:"fire", power:2}, {type:"cold", power:2}],
        spellCriticalDamage:[{type:"universal", power:15}, {type:"fire", power:15}, {type:"cold", power:15}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "Grey Staff",
        group: "Magical Armament",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "armament",
        damage: "3d6",
        damageType: "force",
        crit: "19-20x3",
        range: "60ft",
        spCost: 4,
        special: "When casting a ray spell you can add the enchantments of this weapon to it, including enhancement modifiers to both attack and damage. When you use total defense, fighting defensively, or combat expertise while holding this staff, it creates a protective barrier around you, giving you a deflection modifier to your armor class equal to 2 + 1/2 the weapon's enchantment bonus.",
        spellPower:[{type:"universal", power:25}],
        spellCriticalChance:[{type:"universal", power:2}],
        spellCriticalDamage:[{type:"universal", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "unique",
        class: "armament",
        name: "Shard of Holy Light",
        group: "Magical Armament",
        hardness: 10,
        hitPoints: 5,
        handsNeeded: "one",
        type: "armament",
        damage: "2d6",
        damageType: "positive energy",
        crit: "x5",
        range: "50ft",
        spCost: 2,
        special: "Your spells that roll dice to heal that you cast while holding this weapon heal an additional amount as if they had also been struck by this weapon. This only applies on one roll during the spell. When attacking to heal or using the effect all damage enchantments are converted to healing except continuous ones.",
        spellPower:[{type:"universal", power:10}, {type:"positive", power:20}],
        spellCriticalChance:[{type:"universal", power:1}, {type:"positive", power:4}],
        spellCriticalDamage:[{type:"positive", power:25}],
        additionalInfoTags: ["Magical Armament"],
    },
    {
        rarity: "common",
        class: "ranged",
        name: "Throwing Daggers",
        group: "Thrown, Light Blades",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d3",
        damageType: "P or S",
        crit: "x2",
        range: "20ft",
        special: "Thrown Pile. You can use these as a melee weapon, gaining the enchantments on it, except for ranged exclusive ones.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Wushu Dart",
        group: "Thrown, Monk",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d6",
        damageType: "P",
        crit: "x2",
        range: "50ft",
        special: "Thrown Pile. This weapon can use your highest mental modifier instead of dexterity to determine its attack modifier. If you already could, you can instead use it to determine your damage modifier. If you have the flurry of blows perk, you can draw these as free actions as if it were ammunition.",
        additionalInfoTags: ["Thrown Pile"]
    },    
    {
        rarity: "legendary",
        class: "ranged",
        name: "Tomahawk",
        group: "Thrown, Axe",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d10",
        damageType: "S",
        crit: "x2",
        range: "10ft",
        special: "Thrown Pile. You can use these as a melee weapon at a -2 penalty, gaining the enchantments on it, except for ranged exclusive ones. For every 2 range increment penalties an attack with a tomahawk suffers, its critical damage multiplier increases by +1.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "common",
        class: "melee",
        name: "Hand Wraps",
        group: "Monk",
        hardness: 2,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d4",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "Free Slot Unarmed Augmenting",
        additionalInfoTags:["Unarmed Augmenting","Free Slot"]
    },    
    {
        rarity: "common",
        class: "melee",
        name: "Light Mace",
        group: "Hammer",
        hardness: 10,
        hitPoints: 10,
        type: "light",
        damage: "1d6",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "-",
    },
    {
        rarity: "common",
        class: "melee",
        name: "Punching Dagger",
        type: "augmenting",
        group: "Close",
        hardness: 10,
        hitPoints: 2,
        damage: "1d3",
        damageType: "P",
        crit: "x3",
        range: "-",
        special: "Full Slot Unarmed Augmenting.",
        additionalInfoTags:["Unarmed Augmenting","Full Slot"]
    },
    {
        rarity: "common",
        class: "melee",
        name: "Heavy Mace",
        group: "Hammer",
        hardness: 10,
        hitPoints: 20,
        type: "oneHanded",
        damage: "1d8",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "",
    },
    // {
    // rarity: "unique",
    // class: "melee",
    // name: "",
    // type: "oneHanded",
    // damage: "1d6",
    // crit: "x2",
    // range: "10 ft",
    // special: "You can return this weapon to your backpack after throwing it as a movement action",
    // },
    {
        rarity: "common",
        class: "melee",
        name: "Heavy Mace",
        type: "oneHanded",
        group: "Hammer",
        hardness: 10,
        hitPoints: 20,
        damage: "1d8",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "-",
    },
    {
        rarity: "common",
        class: "melee",
        name: "Battle Axe",
        group: "Axe",
        hardness: 5,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d8",
        damageType: "S",
        crit: "x3",
        range: "-",
        special: "-",
    },
    {
        rarity: "common",
        class: "melee",
        name: "Long Spear",
        group: "Spear",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "1d8",
        damageType: "P",
        crit: "x3",
        range: "-",
        special: "Brace, Reach",
    },
    {
        rarity: "common",
        class: "melee",
        name: "Spear",
        group: "Spear",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "1d8",
        damageType: "P",
        crit: "x3",
        range: "20 ft.",
        special: "Brace",
    },
    {
        rarity: "common",
        class: "melee",
        name: "Quarterstaff",
        group: "Double, Monk",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "1d6",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "Double. Enchantments only apply to the main head of this weapon.",
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Blow Gun",
        group: "Thrown",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d2",
        damageType: "P",
        crit: "x2",
        range: "20 ft.",
        special: "This weapon gains your constitution modifier as a bonus to its damage. If you do not have a constitution modifier of at least 0, you cannot use a blowgun.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "constitution"}]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Double Barrel Blow Gun",
        group: "Thrown",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d2",
        damageType: "P",
        crit: "x2",
        range: "20 ft.",
        special: "This weapon fires two shots at once, acting like the manyshot feat. This weapon gains your constitution modifier as a bonus to its damage. If you do not have a constitution modifier of at least +1, you cannot use a double barrel blowgun. If you have additional double barrel blowguns or blowguns, you can attach them together, granting more hits per attack, however for each attached blowgun barrel the bonus damage you gain from constitution reduces by -1, you take a -1 penalty on attacks, and you cannot have more blowgun barrels than constitution modifier.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "constitution"}]
    },
    {
        rarity: "common",
        class: "ranged",
        name: "Light Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two, or one at -2",
        type: "tech",
        damage: "1d10",
        damageType: "P",
        crit: "18-20",
        range: "80 ft.",
        special: "Reloading a light crossbow is a movement action, or a free action with rapid reload. You can add up to 5 damage from your intelligence, this is in addition to any other ability score you would add to its damage.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence",cap: 5}]
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Hand Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "tech",
        damage: "1d6",
        damageType: "P",
        crit: "18-20",
        range: "30 ft.",
        special: "Reloading a hand crossbow is a movement action, or a free action with rapid reload. You can add up to 3 damage from your intelligence, this is in addition to any other ability score you would add to its damage. A hand crossbow does not take up your hand slot.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence",cap: 3}]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Chain Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d6",
        damageType: "P",
        crit: "19-20",
        range: "60 ft.",
        special: "You do not have to reload this crossbow, however if you do not have rapid reload or an ability that would reduce reloading at least 2 steps, you take a -2 penalty on all attack rolls after the first with this weapon per turn. You can add up to 3 damage from your intelligence, this is in addition to any other ability score you would add to its damage. You cannot fire a chain crossbow while prone.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence", cap: 3}]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Belt Fed Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d8",
        damageType: "P",
        crit: "x2",
        range: "60 ft.",
        special: "You do not have to reload this crossbow, however if you do not have rapid reload or an ability that would reduce reloading at least 2 steps, you take a -2 penalty on all attack rolls after the first with this weapon per turn. You can add up to 3 damage from your intelligence, this is in addition to any other ability score you would add to its damage. Each turn in a row after the first that you make a full-round attack action, you can fire an additional shot, however all attacks in a turn take a -4 penalty per extra attack made. You cannot fire a belt fed crossbow while prone.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence", cap: 3}]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Cannith Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d8",
        damageType: "P",
        crit: "18-20",
        range: "80 ft.",
        special: "Reloading a cannith crossbow is a movement action, or a free action with rapid reload. A cannith crossbow deals bonus damage equal to your intelligence bonus, this is in addition to any other ability score you would add to its damage.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence"}]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Shoulder Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "tech",
        damage: "2d12",
        damageType: "P",
        crit: "18-20",
        range: "80 ft.",
        special: "Reloading a Shoulder crossbow is a standard action, or a swift action with rapid reload. A shoulder crossbow does not require a hand except when firing or reloading it. You can add up to 5 damage from your intelligence, this is in addition to any other ability score you would add to its damage.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence", cap: 5}]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Crossbow Emplacement",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "tech",
        damage: "2d8",
        damageType: "P",
        crit: "18-20",
        range: "80 ft.",
        special: "A crossbow emplacement can be fired 10 times before needing to be reloaded. Reloading a crossbow emplacement is a full-round action, or a standard action with rapid reload. In order to fire a crossbow emplacement you must spend a movement action placing it down on the ground. You can add up to 5 damage from your intelligence, this is in addition to any other ability score you would add to its damage. If set up while standing up, you cannot fire it while prone and vice versa.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence", cap: 5}]
    },
    {
        rarity: "common",
        class: "ranged",
        name: "Javelins",
        group: "Thrown, Spear",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d6",
        damageType: "P",
        crit: "x2",
        range: "30 ft.",
        special: "Thrown Pile. You can make melee attacks with a javelin with a -4 penalty. This counts as a one-handed weapon.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "common",
        class: "melee",
        name: "Sickle",
        group: "Light Blades",
        hardness: 5,
        hitPoints: 2,
        handsNeeded: "one",
        type: "light",
        damage: "1d6",
        damageType: "S",
        crit: "x2",
        range: "",
        special: "Trip(+2)",        
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Pilum",
        group: "Thrown, Spear",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d8",
        damageType: "P",
        crit: "x2",
        range: "20 ft.",
        special: "Thrown Pile. If you hit a shieldbearing opponent with a pilum, he loses the AC bonuses from that shield until he takes a standard action to pry the remnants of the pilum from his shield. This counts as a one-handed weapon.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Amentum",
        group: "Thrown, Spear",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d6",
        damageType: "P",
        crit: "x2",
        range: "50 ft.",
        special: "Thrown Pile. This counts as a one-handed weapon.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "common",
        class: "ranged",
        name: "Heavy Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d12",
        damageType: "P",
        crit: "19-20/x3",
        range: "120 ft.",
        special: "Reloading a heavy crossbow is a standard action, or a free action with rapid reload. You can add up to 5 damage from your intelligence, this is in addition to any other ability score you would add to its damage.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence",cap: 5}]
    },
    {
        rarity: "common",
        class: "ranged",
        name: "Short Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d6",
        damageType: "P",
        crit: "x3",
        range: "60 ft.",
        special: "-",
        weaponTags: ["non-strength"],
    },
    {
        rarity: "common",
        class: "melee",
        name: "Great Club",
        group: "Hammer",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "1d10",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "-",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Tetsubo",
        group: "Hammer",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d8",
        damageType: "B",
        crit: "x3",
        range: "-",
        special: "You can make bull rushes with this weapon. When you do, you gain a +4 bonus, and if the attempt is successful it deals the weapon's damage dice of damage per 10 feet you move them.",
    },
    {
        rarity: "common",
        class: "melee",
        name: "Short Spear",
        group: "Spear",
        hardness: 5,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d6",
        damageType: "P",
        crit: "x3",
        range: "20 ft.",
        special: "-",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Light Pick",
        group: "Axe",
        hardness: 5,
        hitPoints: 2,
        type: "light",
        damage: "1d4",
        damageType: "P",
        crit: "x4",
        range: "-",
        special: "-",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Light Hammer",
        group: "Hammer",
        hardness: 5,
        hitPoints: 2,
        type: "light",
        damage: "1d6",
        damageType: "B",
        crit: "x3",
        range: "20ft",
        special: "This weapon can be thrown as a range weapon with an increment of 20ft",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Spiked Gauntlet",
        group: "Close",
        hardness: 10,
        hitPoints: 5,
        type: "augmenting",
        damage: "1d6",
        damageType: "P",
        crit: "x2",
        range: "-",
        special: "Free Slot Unarmed Augmenting. You can only wield this when wearing medium or heavy armor.",
        additionalInfoTags:["Unarmed Augmenting","Free Slot"]
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Brass Knuckles",
        group: "Close",
        hardness: 10,
        hitPoints: 5,
        type: "augmenting",
        damage: "1d6",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "Half Free Unarmed Augmenting",
        additionalInfoTags:["Unarmed Augmenting","Half Free"]
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Wakizashi",
        hardness: 10,
        hitPoints: 2,
        group: "Light Blade",
        type: "light",
        damage: "1d6",
        damageType: "P or S",
        crit: "18-20",
        range: "-",
        special: "Gain +2 to confirm critical hits, and it deals +4 damage on critical hits (before being multiplied).",
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Shuriken",
        group: "Monk, Thrown",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d2",
        damageType: "P",
        crit: "19-20",
        range: "10 ft",
        special: "Thrown Pile. You can draw these as a free action as if it were ammunition. Additionally, you can throw shuriken while prone with no penalty. If you already possess the ability to draw these as a free action, you can throw an additional shuriken as a part of a full-round attack, however each attack takes a -2 penalty. This stacks for each additional way of drawing shuriken as a free action you have. This counts as a light weapon.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Kunai",
        group: "Monk, Thrown",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d6",
        damageType: "P",
        crit: "19-20",
        range: "20 ft",
        special: "Thrown Pile. You can throw Kunai while prone with no penalty. A kunai can be used as a melee weapon at a -2 penalty, gaining all of its enchantments except ranged exclusive ones. If a kunai deals sneak attack damage, it deals an additional point of damage per sneak attack dice rolled. This counts as a light weapon.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "common",
        class: "ranged",
        name: "Jagged Rocks",
        group: "Thrown",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d2",
        damageType: "P",
        crit: "x2",
        range: "15 ft",
        special: "Thrown Pile. Jagged rocks gain all bonuses you gain from perks and abilities that enhance your ability to throw rocks. This counts as a light weapon.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Smooth River Stones",
        group: "Thrown",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d6",
        damageType: "B",
        crit: "x5",
        range: "20 ft",
        special: "Thrown Pile. Smooth River Stones gain all bonuses you gain from perks and abilities that enhance your ability to throw rocks. This counts as a light weapon.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Katana",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d10",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "Finessable, Gain +2 to confirm critical hits, and it deals +2 damage on critical hits (before being multiplied)",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Dueling Sword",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d12",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "When fighting defensively, using combat expertise, or total defense, increase the bonus to AC you gain by +1. Once per round if a creature misses you by an amount less than your bonus from these abilities, it provokes an attack of opportunity from you.",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Scimitar",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d8",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "-",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Seax",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d12",
        damageType: "P and S",
        crit: "19-20",
        range: "-",
        special: "This weapon can only use strength to determine its attack and damage.",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Handaxe",
        group: "Axe",
        hardness: 5,
        hitPoints: 5,
        type: "light",
        damage: "1d6",
        damageType: "S",
        crit: "x3",
        range: "-",
        special: "-",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Rapier",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d6",
        damageType: "P",
        crit: "18-20",
        range: "-",
        special: "Finessable. You can't wield a rapier in two hands in order to apply 1-1/2 times your Strength bonus to damage.",
    },
    {
        rarity: "common",
        class: "melee",
        name: "Longsword",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d8",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "-",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Seven-branched Sword",
        group: "Heavy Blade, Monk",
        hardness: 10,
        hitPoints: 5,
        handsNeeded: "two",
        type: "twoHanded",
        damage: "1d12",
        damageType: "S",
        crit: "x3",
        range: "-",
        special: "Disarm(+2). You can make a special maneuver with this weapon, doing so is done as if making a trip attempt, but instead of tripping them if successful, they are flat-footed for the remainder of the round.",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Great Sword",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d6",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "-",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Falchion",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d6",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "-",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Paired Blade",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d8",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "While using this in your off-hand while two-weapon fighting, you gain +2 to attack with this weapon. If you are wielding two paired blades while two-weapon fighting both gain +4 attack instead.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Butterfly Knife",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d6",
        damageType: "P",
        crit: "18-20",
        range: "-",
        special: "You can draw this weapon as a free action if you succeed a dc 15 performance check. If you draw it this way and strike a target in the same turn you can roll another performance check to demoralize it. You can use perform instead of intimidate while wielding this weapon. For every enchantment you have on the weapon, gain an additional +1 to perform and damage as the weapon's skin gets better and better, and better skins equals more wins.",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Elven Curved Blade",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d6",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "You can use your highest mental modifier to determine your attack with this weapon. If you already could, you can instead use your highest mental modifier to determine damage instead.",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Orc Skull Ram",
        group: "Spear",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "1d12",
        damageType: "B",
        crit: "x3",
        range: "-",
        special: "On a successful critical hit with this weapon you can make a free bull rush attempt with this weapon which does not provoke, gaining a bonus on the attempt equal to 1/4 of the damage the attack dealt.",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Odachi",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d8",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "This weapon can only be drawn as a full-round action, but can be done while moving up to twice your speed. When you do draw it, all monsters that can see you draw it get a -2 penalty to attack anything except for you, who they get a +2 against, and the DC of fear effects they produce is reduced by -2 until they successfully attack you [mind-affecting]. If you have quickdraw the action to draw this weapon is reduced to a standard action. If you draw this weapon as any less than a full-round action, you cannot move while drawing it. You also cannot draw it as a part of making an attack with a maneuver.",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Trident",
        group: "Spear",
        hardness: 5,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d8",
        damageType: "P",
        crit: "x3",
        range: "10 ft",
        special: "Brace",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Lucerne Hammer",
        group: "Hammer",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "1d12",
        damageType: "B",
        crit: "x2",
        range: "",
        special: "Brace, Reach, Sunder",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Scythe",
        group: "Heavy Blade",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d4",
        damageType: "P or S",
        crit: "x4",
        range: "-",
        special: "Trip(+2)",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Foam Finger On a Stick",
        group: "Polearm",
        hardness: 2,
        hitPoints: 2,
        type: "twoHanded",
        damage: "1d4",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "Reach, You can channel touch spells through this weapon at reach as part of the action you gain to deliver a spell.",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Light Flail",
        group: "Flail",
        hardness: 10,
        hitPoints: 10,
        type: "oneHanded",
        damage: "1d10",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "Disarm, Trip(+2)",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Heavy Pick",
        group: "Axe",
        hardness: 5,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d6",
        damageType: "P",
        crit: "x4",
        range: "-",
        special: "-",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Guisarme",
        group: "Polearm",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d4",
        damageType: "S",
        crit: "x3",
        range: "-",
        special: "Reach, Trip(+2)",
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Long Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d8",
        damageType: "P",
        crit: "x3",
        range: "110ft",
        special: "Add up to 5 damage from strength",
        customWeaponMethods: [{name: "CappedMod", stat: "strength", cap: 5}]
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Steady Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d8",
        damageType: "P",
        crit: "x2",
        range: "60ft",
        special: "Add up to 3 damage from strength. As a movement action you can grant yourself a +4 on your next attack with this weapon this turn. When your BAB reaches +6, this is reduced to a swift action. For each 5 BAB after, the bonus applies to an additional attack.",
        customWeaponMethods: [{name: "CappedMod", stat: "strength", cap: 3}]
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Short Sword",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d6",
        damageType: "P",
        crit: "19-20",
        range: "-",
        special: "-",
    },
    // {
    //     rarity: "rare",
    //     class: "melee",
    //     name: "Starknife",
    //     group: "Light Blade, Thrown",
    //     hardness: 10,
    //     hitPoints: 2,
    //     type: "light",
    //     damage: "1d6",
    //     damageType: "P",
    //     crit: "x3",
    //     range: "20ft.",
    //     special: "Throwing",
    // },
    {
        rarity: "legendary",
        class: "melee",
        name: "Estoc",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "2d6",
        damageType: "P",
        crit: "18-20",
        range: "-",
        special: "Finessable",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Split-Blade Sword",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "2d10",
        damageType: "S",
        crit: "x2",
        range: "-",
        special: "Disarm, Trip(+2). If your dexterity score is lower than 15 you take a -2 to attack with this weapon. If your dexterity is over 20 you gain a +2 bonus to attack with this weapon.",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Bastard Sword",
        hardness: 10,
        hitPoints: 5,
        group: "Heavy Blade",
        type: "oneHanded",
        damage: "1d12",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "This weapon can also count as a two-handed sword.",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Emei Piercer",
        group: "Close, Monk",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d4",
        damageType: "P",
        crit: "19-20",
        range: "-",
        special: "Free Slot Unarmed Augmenting.",
        additionalInfoTags:["Unarmed Augmenting","Free Slot"]
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Rope Gauntlet",
        group: "Close, Monk, Natural",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d12",
        damageType: "B or S",
        crit: "x2",
        range: "-",
        special: "Half Free Unarmed Augmenting, Natural Augmenting. This can only augment tail, tentacle, and hoof attacks. When you confirm a critical hit with this weapon, the creature must make a fortitude save (DC=10 + BAB + strength modifier + enhancement modifier) or become stunned for the rest of the turn. This counts as a one-handed weapon.",
        additionalInfoTags:["Unarmed Augmenting","Half Free","Natural Augmenting"]
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Scizore",
        group: "Close, Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d12",
        damageType: "P",
        crit: "x2",
        range: "-",
        special: "Full Slot Unarmed Augmenting. Grants a shield bonus to AC equal the weapon's enhancement bonus +1, but if you attack with the blade, you lose the AC bonus that round and take a -1 penalty on attack rolls with it. This counts as a one-handed weapon.",
        additionalInfoTags:["Unarmed Augmenting","Full Slot"]
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Cestus",
        group: "Close, Monk",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d8",
        damageType: "B or P",
        crit: "19-20",
        range: "-",
        special: "Half Free Unarmed Augmenting",
        additionalInfoTags:["Unarmed Augmenting","Half Free"]
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Tekko-kagi",
        group: "Close",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d6",
        damageType: "P",
        crit: "x3",
        range: "-",
        special: "Half Free Unarmed Augmenting. Disarm(+2), Sunder(+2), grants +4 to climb checks while using the hand to climb. Grants a shield bonus to AC equal the weapon's enhancement bonus +1 and counts as a buckler, but if you attack with it, you lose the AC bonus that round and take a -1 penalty on attack rolls with it.",
        additionalInfoTags:["Unarmed Augmenting","Half Free"]
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Wolf Claw",
        group: "Close, Monk",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d8",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "Full Slot Unarmed Augmenting, Natural Augmenting, Grapple",
        additionalInfoTags:["Unarmed Augmenting","Full Slot", "Natural Augmenting"]
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Aklys",
        group: "Hammer, Thrown",
        hardness: 5,
        hitPoints: 2,
        type: "light",
        damage: "1d8",
        damageType: "B",
        crit: "x2",
        range: "20ft",
        special: "Trip (+2). Throwable. This weapon can be retrieved as a movement action once thrown as long as it is within its first range increment, and can be used to make trip attacks at range.",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Kusarigama",
        group: "Double, Flail, Monk",
        hardness: 5,
        hitPoints: 2,
        type: "twoHanded",
        damage: "1d6",
        damageType: "B or P",
        crit: "19-20",
        range: "",
        special: "Double, Grapple(+2), Monk, Reach, Trip(+2). Enchantments apply only to the main hand attacks of this weapon, plus 1 enchantment of your choice to the off-hand attacks (can be changed at the beginning of your turn as a free action).",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Dwarven Maulaxe",
        group: "Axe",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d8",
        damageType: "B or S",
        crit: "x3",
        range: "10ft",
        special: "This weapon can be thrown as a range weapon with an increment of 10ft.",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Falcata",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d10",
        damageType: "S",
        crit: "19-20x3",
        range: "-",
        special: "-",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Dwarven War Axe",
        group: "Axe",
        hardness: 10,
        hitPoints: 20,
        type: "oneHanded",
        damage: "1d12",
        damageType: "S",
        crit: "x3",
        range: "-",
        special: "-",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Kopesh",
        group: "Heavy Blades",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d8",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "+2 to feint checks, You can spend a swift action to gain a +2 bonus on your next weapon attack before the end of your turn. For every +4 of your bab you have, the bonus to attacks and feints this gives increases by +1.",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Butchering Axe",
        group: "Axe",
        hardness: 10,
        hitPoints: 10,
        type: "twoHanded",
        damage: "3d6",
        damageType: "S",
        crit: "x3",
        range: "-",
        special: "This weapon can only use strength for attack and damage.",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Orc Double Axe",
        group: "Axe, Double",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "1d8",
        damageType: "S",
        crit: "x3",
        range: "-",
        special: "Double. The off-head gains half the enhancement bonus gained from enchantments of this weapon, and 1 additional enchantment of your choice (not enhancement bonus). It can be changed at the beggining of a turn as a free action.",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Fauchard",
        group: "Polearm",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "1d10",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "Reach, Trip(+2)",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Sawtooth Sabre",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d10",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Flickmace",
        group: "Hammer",
        hardness: 5,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d8",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "Reach, Trip (+2)",
    },
    // {
    //     rarity: "legendary",
    //     class: "melee",
    //     name: "Warhammer",
    //     group:"Hammer",
    //     hardness:5,
    //     hitPoints:5,
    //     type: "oneHanded",
    //     damage: "2d6",
    //     damageType:"B",
    //     crit: "x3",
    //     range: "-",
    //     special: "This weapon gains +1 damage for each dice step increase it has.",
    // },
    {
        rarity: "epic",
        class: "melee",
        name: "Swordbreaker Dagger",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d8",
        damageType: "S",
        crit: "x3",
        range: "-",
        special: "Disarm (+4), Sunder (+4)",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Elven Branch Spear",
        group: "Spear",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d8",
        damageType: "P",
        crit: "x3",
        range: "-",
        special: "Reach, Brace, Finessable, Gain +2 to attack on attacks of opportunity.",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Bill",
        group: "Polearm",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "1d10",
        damageType: "S",
        crit: "x2",
        range: "-",
        special: "Brace, Reach, Disarm, Gain +1 shield bonus to AC when using combat expertise, fighting defensively, or total defense.",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Lance",
        group: "Spear",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d6",
        damageType: "P",
        crit: "x3",
        range: "-",
        special: "Reach, Charge attacks with this weapon gain +1 to attack and deal 1d6 extra damage.",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Kama",
        group: "Light Blade, Monk",
        hardness: 5,
        hitPoints: 2,
        type: "light",
        damage: "1d6",
        damageType: "P",
        crit: "x3",
        range: "-",
        special: "Trip (+4), Grapple (+2), you can deal off-hand damage when you successfully trip, reposition, drag, or grapple an enemy with this weapon.",
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Chakram",
        group: "Heavy Blade, Thrown",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d10",
        damageType: "S",
        crit: "x3",
        range: "30ft",
        special: "Thrown Pile. Can be used as a melee weapon at a -2 penalty to attack.",
        additionalInfoTags: ["Thrown Pile"]
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Swift Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d6",
        damageType: "P",
        crit: "19-20x2",
        range: "60ft",
        special: "Add up to 2 damage from strength and 1 damage from dexterity. If you can add dex to damage it becomes max +3 dex to damage",
        customWeaponMethods: [{name: "cappedMod", stat: "strength", cap: 2}, {name: "additionalMod", stat: "dexterity", cap: 1}]
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Spirit Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d8",
        damageType: "P, B, S",
        crit: "x2",
        range: "80ft",
        special: "This bow cannot have a damage modifier based off an ability score. This weapon adds up to +5 to its damage for every ability score.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "strength", cap: 5}, {name: "additionalMod", stat: "dexterity", cap: 5},{name: "additionalMod", stat: "constitution", cap: 5},{name: "additionalMod", stat: "wisdom", cap: 5},{name: "additionalMod", stat: "intelligence", cap: 5},{name: "additionalMod", stat: "charisma", cap: 5},]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Elven Short Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d6",
        damageType: "P",
        crit: "18-20",
        range: "60ft",
        special: "Add up to 5 damage from strength and 2 damage from dexterity. If you can add dex to damage it becomes max +7 dex to damage",
        customWeaponMethods: [{name: "cappedMod", stat: "strength", cap: 5}, {name: "additionalMod", stat: "dexterity", cap: 2}]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Wind Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d8",
        damageType: "P",
        crit: "19-20x3",
        range: "60ft",
        special: "Add up to 7 damage from strength, and 3 damage from dexterity. If you can add dex to damage it becomes max +10 dex to damage",
        customWeaponMethods: [{name: "cappedMod", stat: "strength", cap: 7}, {name: "additionalMod", stat: "dexterity", cap: 3}]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Assassin's Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d8",
        damageType: "P",
        crit: "x3",
        range: "60ft",
        special: "Add up to 5 damage from your dexterity as bonus damage. When attacking an enemy within 30 feet, if the nearest adjacent space to your target is unoccupied and the opposite space is occupied by a threatening ally, you are considered flanking that enemy, including granting you and your ally a +2 bonus on attack rolls.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "dexterity", cap: 5}]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Bow of the Seasons",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "2d6",
        damageType: "variant",
        crit: "19-20",
        range: "80ft",
        special: "This bow's damage is determined by your highest mental modifier. Each turn at the start of your turn, roll 1d4 to determine what type of damage this bow deals. 1: fire, 2: acid, 3: cold, 4: electricity.",
        weaponTags: ["non-strength"],        
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Storm Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d8",
        damageType: "P",
        crit: "17-20",
        range: "60ft",
        special: "Add up to 5 damage from strength, and 10 damage from dexterity. If you can add dex to damage it becomes max +15 dex to damage",
        customWeaponMethods: [{name: "cappedMod", stat: "strength", cap: 5}, {name: "additionalMod", stat: "dexterity", cap: 10}]
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Chrysos Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "1d8",
        damageType: "P",
        crit: "18-20x3",
        range: "60ft",
        special: "Add up to 10 damage from strength, and 5 damage from dexterity. If you can add dex to damage, it becomes max +15 dex to damage. When making an attack as a standard action or attack action, you can apply feats that modify a full-round attack with a ranged weapon. Any additional attacks get no bonuses the first attack gets unless it would affect all attacks made in a full-round attack.",
        customWeaponMethods: [{name: "cappedMod", stat: "strength", cap: 10}, {name: "additionalMod", stat: "dexterity", cap: 5}]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Great Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "2d6",
        damageType: "P",
        crit: "x3",
        range: "125ft",
        special: "You can add your full strength modifier to damage with this weapon",
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Heavy Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 10,
        handsNeeded: "two",
        type: "primitive",
        damage: "2d8",
        damageType: "P",
        crit: "x4",
        range: "150ft",
        special: "You can add your full strength modifier to damage with this weapon, and you can use this as a two-handed melee greatclub that deals 1d10 B damage, 20x2. Enchantments on the bow apply to the club, except for ranged exclusive enchantments.",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Sword Cane",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "oneHanded",
        damage: "1d8",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "Drawable as a swift action that doesn't provoke attacks of opportunity. If you draw this weapon and declare an attack against a creature with it on the same round you can make a bluff check as if feinting as a free action. This effect can only be used on a creature once.",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Gladius",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d12",
        damageType: "S or P",
        crit: "19-20",
        range: "-",
        special: "",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Klar",
        group: "Close, Heavy Blade",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d8",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "Full Slot Unarmed Augmenting. When wielded like a shield it gives +2 shield bonus to ac, and even if you attack with it you still gain a +1 shield bonus to ac and you count as having a shield equipped.",
        additionalInfoTags:["Full Slot", "Unarmed Augmenting"]
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Kerambit",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d8",
        damageType: "P or S",
        crit: "x2",
        range: "-",
        special: "When attacking a target you are considered flanking you gain +2 to attack, this stacks with the usual flanking bonus, and the weapon's critical becomes 18-20x3",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Morphblade",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "1d12",
        damageType: "S and P",
        crit: "x2",
        range: "-",
        special: "You can make a strike with this weapon from any school of maneuvers regardless of weapon requirements, but its range decreases to melee unless it allows you to make melee attacks at range.",
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Light Crank Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two, or one at -2",
        type: "tech",
        damage: "1d10",
        damageType: "P",
        crit: "18-20",
        range: "80",
        special: "Can be shot 5 times before needing to reload. Requires a full-round action to reload, or a swift action with rapid reload. You can add up to 5 damage from your intelligence, this is in addition to any other ability score you would add to its damage.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence",cap: 5}]
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Heavy Crank Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d12",
        damageType: "P",
        crit: "19-20x3",
        range: "120",
        special: "Can be shot 5 times before needing to reload. Requires a full-round action to reload, or a swift action with rapid reload. You can add up to 5 damage from your intelligence, this is in addition to any other ability score you would add to its damage.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence",cap: 5}]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Heavy Repeating Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d12",
        damageType: "P",
        crit: "19-20x3",
        range: "120",
        special: "Can be shot 5 times before needing to reload, requires a full-round action to reload, or a swift action with rapid reload. When making a full-round attack with this crossbow, you can fire an additional shot, however all attacks during the turn take a -4 penalty to attack. You can add up to 5 damage from your intelligence, this is in addition to any other ability score you would add to its damage.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence",cap: 5}]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Light Repeating Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two, or one at -2",
        type: "tech",
        damage: "1d10",
        damageType: "P",
        crit: "18-20",
        range: "80",
        special: "Can be shot 5 times before needing to reload, requires a full round action to reload, or a swift action with rapid reload. When making a full-round attack with this crossbow, you can fire an additional shot, however all attacks during the turn take a -4 penalty to attack. You can add up to 5 damage from your intelligence, this is in addition to any other ability score you would add to its damage.",
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence",cap: 5}]
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Extendo Sword",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d8",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "You can extend this weapon to give 5 foot reach as an immediate action, and swap it back as a movement action that provokes attacks of opportunity. If you have an ability that reduces the action of sheathing it works with this effect. If you extend this weapon and make an attack of opportunity on the same turn you gain +2 to attack for that attack.",
    },
    {
        rarity: "common",
        class: "melee",
        name: "Whip",
        hardness: 2,
        hitPoints: 2,
        group: "Flail",
        type: "light",
        damage: "1d3",
        damageType: "B",
        crit: "x2",
        range: "-",
        special: "Disarm, Trip(+2), Reach, This weapon has a melee reach of 15 feet, though you don’t threaten the area into which you can make an attack (no AoO's), but can attack adjacent targets. Attacking with a whip provokes as if using a ranged weapon.",
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Scorpion Whip",
        hardness: 2,
        hitPoints: 2,
        group: "Flail",
        type: "light",
        damage: "1d6",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "Disarm, Trip (+2), Reach, This weapon has a melee reach of 15 feet, though you don’t threaten the area into which you can make an attack (no AoO's), but can attack adjacent targets. Attacking with a whip provokes as if using a ranged weapon.",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Spiked Chain",
        hardness: 5,
        hitPoints: 10,
        group: "Flail",
        type: "twoHanded",
        damage: "2d4",
        damageType: "P",
        crit: "x2",
        range: "-",
        special: "Disarm, Trip(+2), Finessable, Reach, however you can still attack adjacent creatures",
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Sadist's Stiletto",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d10",
        damageType: "P",
        crit: "x3",
        range: "",
        special: "You can perform a coup-de-grace as standard action against a target that meets all the normal requirements and it no longer provokes. Additionally, gain +1 to attack and damage against a target for each negative condition they are currently affected by.",
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Rifle",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d10",
        damageType: "P",
        crit: "x4",
        range: "80",
        special: "Requires a movement action to reload, or free with rapid reload",
        weaponTags: ["non-strength"]
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Pistol",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "tech",
        damage: "1d8",
        damageType: "P",
        crit: "x4",
        range: "20ft",
        special: "Reloading a pistol is a standard action, or movement action with rapid reload.",
        weaponTags: ["non-strength"]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Breech-Loader Pistol",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "tech",
        damage: "1d8",
        damageType: "P",
        crit: "x4",
        range: "20ft",
        special: "Reloading a breech loader pistol is a movement action, or swift action with rapid reload.",
        weaponTags: ["non-strength"]
    },
    {
        rarity: "rare",
        class: "ranged",
        name: "Musket",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "tech",
        damage: "1d12",
        damageType: "P",
        crit: "x4",
        range: "40ft",
        special: "Reloading a musket is a full-round action, or standard action with rapid reload.",
        weaponTags: ["non-strength"]
    },
    {
        rarity: "common",
        class: "ranged",
        name: "Air Repeater",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d8",
        damageType: "P",
        crit: "x4",
        range: "50ft",
        special: "This can be fired 6 times before needing to be reloaded. Reloading an air repeater is a 1 minute action, or full-round action with rapid reload.",
        weaponTags: ["non-strength"]
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Pepper Pistol",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "tech",
        damage: "1d8",
        damageType: "P",
        crit: "x4",
        range: "20ft",
        special: "This pistol can be shot 6 times before needing to be reloaded. Reloading a pepper pistol is a standard action, or movement action with rapid reload. You must have a free hand to rotate a pepperbox barrel between each shot (free action).",
        weaponTags: ["non-strength"]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Cylinder Rifle",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d8",
        damageType: "P",
        crit: "x4",
        range: "40ft",
        special: "This gun can be fired 8 times before needing to reload, reloading it takes 2 full-round actions, or 1 full-round action if you have rapid reload",
        weaponTags: ["non-strength"]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Double Crossbow",
        group: "Crossbow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d10",
        damageType: "P",
        crit: "19-20x3",
        range: "80",
        special: "Multishot-2. Reloading both bolts is a standard action, or a move action with rapid reload. You can add up to 5 damage from your intelligence, this is in addition to any other ability score you would add to its damage.",
        additionalInfoTags:["multishot"],
        weaponTags: ["non-strength"],
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence", cap: 5}]
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Revolver",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "tech",
        damage: "1d8",
        damageType: "P",
        crit: "x4",
        range: "20",
        special: "This weapon can be fired 6 times before needing to be reloaded, which is a standard action, or movement action if you have rapid reload",
        weaponTags:["non-strength"],
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Blunderbuss",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d8",
        damageType: "B",
        crit: "x2",
        range: "10ft",
        special: "Scatter. Requires full-round action to reload, or standard with rapid reload. This weapon fires in a 15-foot cone.",
        weaponTags:["non-strength"],
    },
    {
        rarity: "legendary",
        class: "ranged",
        name: "Shotgun",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d8",
        damageType: "B",
        crit: "x2",
        range: "20ft",
        special: "This weapon can be loaded with pellets or slugs. If loaded with pellets, it gains the scatter property and fires in a 30-foot cone. If loaded with slugs, the base damage increases to 3d6. Requires full-round action to reload, or standard action with rapid reload.",
        weaponTags:["non-strength"],
    },
    {
        rarity: "epic",
        class: "ranged",
        name: "Culverin",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "2d8",
        damageType: "B",
        crit: "x4",
        range: "30ft",
        special: "Firing a culverin while not prone gives a -4 penalty, and the wielder is knocked prone. Reloading a culverin is a full-round action, or standard action with rapid reload.",
        weaponTags:["non-strength"],
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Dragoon Pistol",
        group: "Firearm",
        handsNeeded: "one",
        type: "tech",
        damage: "1d8",
        damageType: "P and B",
        crit: "x3",
        range: "30",
        special: "Multishot-2. This pistol requires a standard action to reload, or movement action with rapid reload.",
        additionalInfoTags:["multishot"],
        weaponTags:["non-strength"],
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Dragoon Musket",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "1d10",
        damageType: "P and B",
        crit: "x3",
        range: "60",
        special: "Multishot-3. This musket a full-round action to reload, or standard action with rapid reload.",
        additionalInfoTags:["multishot"],
        weaponTags:["non-strength"],
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Lance Bow",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "3d6",
        damageType: "P and B",
        crit: "19-20 x3",
        range: "500 ft",
        special: "You can add your full strength to ranged damage, and can use this as a two-handed melee lance that deals 2d6 B damage, 20x3. Enchantments on the bow apply to the club, except for ranged exclusive enchantments. Ranged crits pierce the target allowing you to select another target behind the target of the crit (you must be able to draw a line from yourself and through both targets), roll to hit normally with a -4 penalty to attack, but deal damage normally. If you used any special abilities or ammunition on a piercing shot it only applies to the first target, unless it would affect all attacks in a round.",
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Final Whisper",
        group: "Bow",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "primitive",
        damage: "3d6",
        damageType: "P",
        crit: "x4",
        range: "500 ft",
        special: "You can add your full strength to ranged damage. When attacking a creature beyond 30 feet from you, you gain a +2 bonus on damage rolls with this weapon. For every 10 feet beyond that 30 feet you gain an additional +1 point of damage. This damage is precision damage. When you score a successful critical hit with this weapon, the target takes 2 points of constitution drain.",
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Super Shotgun",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "tech",
        damage: "3d6",
        damageType: "P and B",
        crit: "x4",
        range: "15 ft",
        special: "Scatter. Requires full-round action to reload, or standard with rapid reload. This weapon fires in a 30-foot cone. As a standard action you can fire a hook at an enemy within 30 feet requiring a ranged touch attack, if you succeed you can pull yourself in a direct line towards them, landing adjacent. As a full-round action you can shoot your hook at an enemy, and then fire directly after landing. Movement during the hook ability provokes as normal, except from the hooked creature. This weapon's critical multiplier increases to x6 against demons.",
        weaponTags: ["non-strength"],
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Rising Sun",
        group: "Heavy Blade, Thrown",
        hardness: 10,
        hitPoints: 2,
        handsNeeded: "one",
        type: "primitive",
        damage: "1d10",
        damageType: "S",
        crit: "x3",
        range: "10 ft",
        special: "If this weapon is using strength to determine its damage modifier it gains a bonus to damage equal to your dexterity modifier. For each range increment penalty an attack with this weapon is suffering, its critical threat range increases by a flat +1.",
        customModifier:(context, modifier)=>{
            if(context.statsForAbilities.dmgStat == "strength" && Math.floor((context.character.modifiedStats["dexterity"]-10)/2) > 0 ){
                modifier += Math.floor((context.character.modifiedStats["dexterity"]-10)/2)
            }
            return modifier
        }
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Assassin's Shiv",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "1d10",
        damageType: "P",
        crit: "19-20",
        range: "-",
        special: "Critical hits with this weapon multiply sneak attack damage, and critical hits always apply sneak attack, but it is not multiplied unless you would have applied sneak attack without a critical hit. Gain 2d6 sneak attack damage with attacks with this weapon.",
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Tonfa",
        group:"Close",
        hardness:5,
        hitPoints:2,
        type: "augmenting",
        damage: "1d6",
        damageType:"B",
        crit: "x2",
        range: "-",
        special: "Full Slot Unarmed Augmenting. Blocking. When you charge and attack with this weapon, you can take a 5-foot step afterwards as long as you end your turn within this weapon's reach of the target.",
        additionalInfoTags:["Unarmed Augmenting", "Full Slot"]
    },
    {
        rarity: "rare",
        class: "melee",
        name: "Iron Ridges",
        group:"natural",
        hardness:10,
        hitPoints:2,
        type: "augmenting",
        damage: "1d4",
        damageType:"S",
        crit: "19-20",
        range: "-",
        special: "Natural Augmenting",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Boulder Gauntlets",
        group: "Monk",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "2d10",
        damageType: "B",
        crit: "x4",
        range: "-",
        special: "Free Slot Unarmed Augmenting. As a full-round action you can make an attack roll against all creatures within your reach to deal damage normally, if the attack roll beats their CMD vs trip they are also knocked prone. If they fall prone, it provokes an attack of opportunity from you, but you get a -8 to attack.",
        additionalInfoTags:["Unarmed Augmenting","Free Slot"]
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Butterfly Wraps",
        group: "Monk",
        hardness: 2,
        hitPoints: 2,
        type: "augmenting",
        damage: "2d6",
        damageType: "B",
        crit: "19-20x3",
        range: "-",
        special: "Free Slot Unarmed Augmenting. During your turn, as long as you have not made an attack yet, you can take an additional 5-foot step. Taking this 5-foot step does not stop you from taking your normal 5-foot step later, even if you have attacked. When a creature misses you with an attack, as long as you had a 5-foot step available at the end of your last turn, you can make an attack against them with this weapon as an immediate action. If you had multiple 5-foot steps available at the end of your last turn, the bonus damage you gain from power attack is doubled for each additional remaining 5-foot step.",
        additionalInfoTags:["Unarmed Augmenting","Free Slot"]
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Elemental Gloves",
        group: "Monk",
        hardness: 5,
        hitPoints: 5,
        type: "augmenting",
        damage: "2d6",
        damageType: "B",
        crit: "18-20",
        range: "-",
        special: "Free Slot Unarmed Augmenting. When you use power attack with this weapon, you can choose for it to not reduce your attack bonus and cause the additional damage to become an elemental damage type of your choice (fire, electricity, acid, cold).",
        additionalInfoTags:["Unarmed Augmenting","Free Slot"]
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Champion's Mitt",
        group: "Monk, Close",
        hardness: 2,
        hitPoints: 5,
        type: "augmenting",
        damage: "2d6",
        damageType: "B",
        crit: "x3",
        range: "-",
        special: "Half Free Unarmed Augmenting. As long as you have not made an attack with this weapon this round, you can as a swift action make an attack with it, this also increases the critical range to 19-20x4. Afterwards, you suffer a -4 penalty to armor class and cannot make more attacks with it until the start of your next turn.",
        additionalInfoTags:["Unarmed Augmenting","Half Free"]
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Shadow Claw",
        group: "Monk, Natural, Close",
        hardness: 2,
        hitPoints: 5,
        type: "augmenting",
        damage: "1d8",
        damageType: "negative energy",
        crit: "19-20x3",
        range: "-",
        special: "Full Slot Unarmed Augmenting, Natural Augmenting. When you kill a living creature with this weapon, the claw becomes empowered for the rest of the floor, increasing its reach by 5 feet. This stacks.",
        additionalInfoTags:["Unarmed Augmenting","Full Slot", "Natural Augmenting"]
    },
    {
        rarity: "epic",
        class: "melee",
        name: "Iron Spike",
        group: "Natural, Close",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d6",
        damageType: "S",
        crit: "x4",
        range: "-",
        special: "Free Slot Unarmed Augmenting, Natural Augmenting. This cannot augment bite attacks.",
        additionalInfoTags:["Natural Augmenting", "Unarmed Augmenting", "Free Slot"]
    },
    {
        rarity: "legendary",
        class: "melee",
        name: "Tailblade",
        group: "natural, light blade",
        hardness: 10,
        hitPoints: 2,
        type: "augmenting",
        damage: "1d8",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "Natural Augmenting. This weapon can only augment tail or tentacle attacks. If you have a tail, but it does not provide a natural attack, you can still augment it with this, granting you a secondary tail attack, but the base damage dice is reduced to 1d4.",
        additionalInfoTags:["Natural Augmenting"]
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Iron Arm",
        group: "Monk, Close, Hammer,",
        hardness: 10,
        hitPoints: 10,
        type: "augmenting",
        damage: "2d6",
        damageType: "B",
        crit: "x3",
        range: "-",
        special: "Full Slot Unarmed Augmenting. This can be equipped to both of your arms at once to deal damage as if it were a two-handed weapon. Adding or removing an arm takes a movement action. This counts as a one-handed weapon.",
        additionalInfoTags:["Unarmed Augmenting","Full Slot"]
    },
    // {
    //     rarity: "unique",
    //     class: "melee",
    //     name: "Iron Arm",
    //     group: "Monk, Close, Hammer,",
    //     hardness: 10,
    //     hitPoints: 10,
    //     type: "augmenting",
    //     damage: "2d6",
    //     damageType: "B",
    //     crit: "x3",
    //     range: "-",
    //     special: "Free Slot Unarmed Augmenting. ",
    //     additionalInfoTags:["Unarmed Augmenting","Free Slot"]
    // },
    {
        rarity: "legendary",
        class: "melee",
        name: "Arm Blade",
        group: "Monk, Close",
        hardness: 10,
        hitPoints: 10,
        type: "augmenting",
        damage: "1d8",
        damageType: "B",
        crit: "x3",
        range: "-",
        special: "Full Slot Unarmed Augmenting, Natural Augmenting. This can only augment tail and tentacle attacks. When you use power attack with this weapon, instead of gaining a bonus to your damage, you can instead gain a shield bonus to your armor class equal to the penalty to attack that power attack is giving.",
        additionalInfoTags:["Unarmed Augmenting","Full Slot", "Natural Augmenting"]
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Duelist's Piercer",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "2d10",
        damageType: "P",
        crit: "18-20",
        range: "-",
        special: "Finessable. Gain +4 on all rolls associated with a counter with this weapon, if you critical hit with this weapon on a counter that includes an attack the critical multiplier is increased by 1",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Masamune",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 10,
        type: "twoHanded",
        damage: "3d6",
        damageType: "S and P",
        crit: "18-20 x3",
        range: "-",
        special: "Finessable. You can use dexterity for damage with this weapon while wielding it in both hands. Once per round when you make an attack with this weapon while using dexterity for attack you can sheathe it immediately after the attack. If you attack on the same turn you drew this weapon gain +4 attack. You can spend a swift action to increase your reach with this weapon by 5 feet until the start of your next turn, but you suffer a -2 penalty on attacks. When your BAB reaches +6, and every 5 after, the reach increase lasts an additional round, and it stacks.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Ejecting Blade",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "2d6",
        damageType: "S",
        crit: "19-20",
        range: "-",
        special: "This weapon can't be used like a standard weapon, instead, when two-weapon fighting, if you hit and deal damage with both of your weapon's during one turn, you can make an additional attack with this weapon against the target you struck with both weapons, using your lowest bab attack modifier. The target is considered flat-footed for the attack, and the attack deals +5 bonus damage per successful attack against them you made this turn. This bonus attack is considered to be apart of your two-weapon fighting.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Precision Blade",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "2d6",
        damageType: "P or S",
        crit: "17-20",
        range: "-",
        special: "Finessable. Abilities that only activate on natural 20s instead activate on 19-20 when wielding this weapon, if this weapon has keen or a similair ability they activate on 18-20",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Gunblade",
        group: "Heavy Blade, firearm",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "2d6",
        damageType: "S",
        crit: "19-20",
        range: "40ft.",
        special: "This sword can also be used as a firearm. It holds 6 bullets and deals 1d8 P damage, 20x4. It is reloaded as a full-round action, or standard with rapid reload. If you confirm a critical hit while using it as a melee weapon, you can as a swift action fire it at the target of the critical hit at a -4 penalty. This attack does not provoke. Enchantments on the sword apply to the firearm, except for melee exclusive enchantments.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Dragon Spear",
        group: "Polearm, Spear",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "3d6",
        damageType: "P or B",
        crit: "19-20 x3",
        range: "-",
        special: "Reach, Trip(+2), Finessable. This weapon still threatens and can be used to attack adjacent targets",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Heaven Piercing Lance",
        group: "Spear",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d10",
        damageType: "P and B",
        crit: "x3",
        range: "-",
        special: "Reach, Brace. If you move at least 20 feet while charging this lance, it deals double damage. If you have multiple attacks on a charge, this applies only to the first attack.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Felglaive",
        group: "Double, Light Blade",
        hardness: 10,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d6",
        damageType: "S",
        crit: "18-20",
        range: "-",
        special: "Double, Finessable. Enchantments placed on this weapon apply to both ends of the weapon.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Executioner's Scythe",
        group: "Heavy Blade",
        hardness: 5,
        hitPoints: 10,
        type: "twoHanded",
        damage: "2d8",
        damageType: "P or S",
        crit: "19-20 x4",
        range: "-",
        special: "This weapon automatically confirms critical hits, effects that only activate on natural 20s don't activate unless you confirm them normally, but you gain a +4 to that roll.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Buster Sword",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 10,
        type: "twoHanded",
        damage: "3d8",
        damageType: "S and B",
        crit: "18-20",
        range: "-",
        special: "Sunder. This weapon can only use strength for attack and damage. While wielding this in two hands, you don't suffer the attack penalty from power attack.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Superior's Edge",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "2d6",
        damageType: "P or S",
        crit: "18-20",
        range: "",
        special: "You can use your highest mental stat to determine your attack and damage modifiers with this weapon.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Giant Hunk Of Iron",
        group: "Hammer",
        hardness: 10,
        hitPoints: 30,
        type: "twoHanded",
        damage: "4d6",
        damageType: "B",
        crit: "-",
        range: "",
        special: "This weapon can only use strength for attack and damage and must always be wielded in two hands (no matter the ability). It deals 2x strength modifier for damage instead of 1.5x, this weapon cannot critically hit even if you have increased crit range. Abilities that activate on a natural 20 still work with this weapon, but must be confirmed as normal at a -4 penalty.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Wave Motion Blade",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "2d10",
        damageType: "S",
        crit: "18-20",
        range: "",
        special: "Finessable. When you take a 5 foot step while wielding this weapon you can instead move 10 feet. This additional 5 feet of movement provokes attacks of opportunity as usual, but you gain +4 dodge bonus to ac for any attacks made against you during it. If a creature misses you during that attack of opportunity you gain +2 attack and your critical damage multiplier increases by 1 for your next attack against it within 1 round with this weapon.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Duskblade",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "2d6",
        damageType: "S",
        crit: "x4",
        range: "",
        special: "If you attack a creature you are flanking or is denied its dexterity to armor class, the critical threat range of this weapon becomes 19-20 x5. If a creature you have confirmed a critical hit against falls unconcious or dies, you can turn invisible as per the invisibility spell for 2 rounds.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Soul Reaver",
        group: "Light Blade",
        hardness: 10,
        hitPoints: 2,
        type: "light",
        damage: "2d8",
        damageType: "S and P",
        crit: "19-20x3",
        range: "-",
        special: "This weapon treats a creature's fortification as if it was 50% lower. Creatures immune to critical hits and sneak attacks instead have a 50% chance to ignore them. It deals full damage against incorporeal creatures, even if not enchanted.",
    },
    {
        rarity: "unique",
        class: "melee",
        name: "Boardless Sword",
        group: "Heavy Blade",
        hardness: 10,
        hitPoints: 5,
        type: "oneHanded",
        damage: "2d8",
        damageType: "S",
        crit: "18-20",
        range: "",
        special: "When you confirm a critical hit with this weapon you can attack the target of the critical hit with your shield as a free action without losing its bonus to your AC, and it gains an enhancement bonus to attack and damage equal to this weapons'. Gain DR/- equal to the base shield bonus to AC your shield gives you, unmodified by enchantments.",
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Portable Cannon",
        group: "Firearm, Siege Engine",
        hardness: 10,
        hitPoints: 30,
        handsNeeded: "two",
        type: "tech",
        damage: "5d12",
        damageType: "B",
        crit: "x4",
        range: "40 ft",
        special: "Requires 3 full rounds to reload, but can be reduced 2 round with rapid reload, and reduced another round by having an adjacent teammate spend a full-round action helping you reload it. Only 1 teammate can help this way. If they help aim it as a full-round action the range increases to 100 feet. Natural 1's on attack rolls cause this weapon to deal its damage to all creatures in a 15-foot radius including the wielder and gain the broken condition, but does not cause the attack to automatically miss. Deals full damage to objects",
        weaponTags: ["non-strength"],
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "Auto Ballista",
        group: "Crossbow, Siege Engine",
        hardness: 5,
        hitPoints: 20,
        handsNeeded: "two",
        type: "tech",
        damage: "3d12",
        damageType: "B and P",
        crit: "19-20x3",
        range: "80 ft",
        special: "Takes a 1 round to reload, or a standard action with rapid reload. Deals full damage to objects. This weapon gains your intelligence bonus as a bonus on damage, this is in addition to any other ability score you would add to its damage. This weapon ignores cover and total cover provided by walls as long as the wall is thinner than 5 feet, though total cover still provides its miss chance.",
        customWeaponMethods: [{name: "additionalMod", stat: "intelligence"}],
        weaponTags: ["non-strength"],
    },
    {
        rarity: "unique",
        class: "ranged",
        name: ".50 Cal",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "two",
        type: "tech",
        damage: "3d8",
        damageType: "P and B",
        crit: "x4",
        range: "80 ft",
        special: "Requires a full-round action to reload, or a standard with rapid reload. You can as a full round action fire this gun adding your highest mental stat to attack and 2x your highest mental stat to damage on top of any other ability modifier you would add, and increase the critical multiplier and critical range by a flat +1. If fired this way it does not hit against touch ac.",
        weaponTags: ["non-strength"],
    },
    {
        rarity: "unique",
        class: "ranged",
        name: "1911",
        group: "Firearm",
        hardness: 5,
        hitPoints: 5,
        handsNeeded: "one",
        type: "tech",
        damage: "1d12",
        damageType: "P and B",
        crit: "19-20 x4",
        range: "40 ft",
        special: "Can fire 7 shots before reloading. This gun takes a full-round action to reload, or a standard with rapid reload. If you reload this gun while still having shots left it can be shot 8 times before needing to be reloaded. Increase critical threat range to 18-20 x5 against targets you've seen cast a spell (but not spell like ability) and evil outsiders.",
        weaponTags: ["non-strength"],
    },
]

let customWeaponMethodsSet = []
customWeaponMethodsSet["cappedMod"] = (context, stat, cap)=>{
    let amount = 0
    if(Math.floor((context.character.modifiedStats[stat]-10)/2) > cap){
        amount += cap
    }else{
        amount += Math.floor((context.character.modifiedStats[stat]-10)/2)
    }
    return amount
}

customWeaponMethodsSet["additionalMod"] = (context, modifier, cap, stat)=>{
    modifier = parseInt(modifier)
    cap = parseInt(cap)
    if(Math.floor((context.character.modifiedStats[stat]-10)/2) > 0){
        if(cap != "-" && Math.floor((context.character.modifiedStats[stat]-10)/2) > cap){
          modifier += cap
        }else{
          modifier += Math.floor((context.character.modifiedStats[stat]-10)/2)
        }
    }
    return modifier
}

export const customWeaponMethods = customWeaponMethodsSet